export const INITIAL_PER_PAGE = 20
export const PER_PAGE_OPTIONS = [20, 40, 60]
export const RISKS_PER_PAGE = [10, 20, 30]
